import reduceReducers from 'reduce-reducers';
import catalogRead from './catalog-read';

const routeTestReducer = reduceReducers(catalogRead);

export default routeTestReducer;
